import { useEffect, useState } from "react";
import styled from "styled-components";
import {
  CenterView,
  Icon,
  RowView,
  RowView2,
} from "../../../Component/style/common_style";
import { amountFormat } from "../../../Component/tool/Tools";
import LiveList from "./Component/LiveList";
import api from "../../../Component/axios_Interceptor/api";
import url from "../../../Component/server";
import { LiveListItem } from "../../../Component/Interface/Live";
import api2 from "../../../Component/axios_Interceptor/api2";

interface SelectBtnProps {
  $isSelected: boolean;
}

interface UserLiveListProps {
  isLogin: boolean;
}

interface UserInfoProps {
  userid: string;
}

const UserLiveList = ({ isLogin }: UserLiveListProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const [selected, setSelected] = useState("전체");
  const [liveList, setLiveList] = useState<LiveListItem[]>([]);
  const [nextLiveList, setNextLiveList] = useState<LiveListItem[]>([]);
  const [userInfo, setUserInfo] = useState<UserInfoProps>();
  const handleSelect = (option: string) => {
    setSelected(option);
  };

  const getMainLiveList = async () => {
    try {
      const userResponse = isLogin
        ? await api.get(url.Communication_url.user_info)
        : null;
      const res = await api2.get(url.Communication_url.get_main_live_list, {
        params: {
          userid: isLogin && userResponse ? userResponse.data.userid : "",
        },
      });
      setLiveList(res.data);
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    } catch (error) {
      console.log(error);
    }
  };

  const getFollowLiveList = async () => {
    try {
      const res = await api.get(url.Communication_url.get_follow_live_list);
      setLiveList(res.data.broadcasting);
      setNextLiveList(res.data.scheduled);
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (selected === "찜") {
      if (isLogin) {
        getFollowLiveList();
      }
    } else {
      getMainLiveList();
    }
    setIsLoading(true);
  }, [selected]);

  return (
    <Container>
      <SelectDiv>
        <SelectBtn
          $isSelected={selected === "전체"}
          onClick={() => {
            handleSelect("전체");
          }}
        >
          공개 라이브
        </SelectBtn>
        {isLogin && (
          <SelectBtn
            $isSelected={selected === "찜"}
            onClick={() => {
              handleSelect("찜");
            }}
          >
            시크릿 라이브
          </SelectBtn>
        )}
      </SelectDiv>

      {selected === "찜" && (
        <div
          style={{
            color: "white",
            marginTop: 10,
            fontSize: 18,
            fontFamily: "var(--font-Pretendard-SemiBold)",
          }}
        >
          라이브
        </div>
      )}
      {isLoading ? (
        <Loading>
          <div className="loading" />
        </Loading>
      ) : liveList.length > 0 ? (
        <LiveList
          liveList={liveList}
          isLive={true}
          search_live={selected === "찜" ? getFollowLiveList : getMainLiveList}
          isLogin={isLogin}
          follow={selected}
        />
      ) : (
        <NullDiv>현재 라이브중인 스토어가 없습니다.</NullDiv>
      )}
      {selected === "찜" && (
        <>
          <div
            style={{
              color: "white",
              marginTop: 65,
              fontSize: 18,
              fontFamily: "var(--font-Pretendard-SemiBold)",
            }}
          >
            라이브 예정
          </div>
          {isLoading ? (
            <Loading>
              <div className="loading" />
            </Loading>
          ) : nextLiveList.length > 0 ? (
            <LiveList
              liveList={nextLiveList}
              isLive={false}
              search_live={isLogin ? getFollowLiveList : getMainLiveList}
              isLogin={isLogin}
              follow={selected}
            />
          ) : (
            <NullDiv>라이브 예정인 스토어가 없습니다.</NullDiv>
          )}
        </>
      )}
    </Container>
  );
};

export default UserLiveList;

const Container = styled.div`
  padding: 16px;
  margin-top: 18px;
`;

const SelectDiv = styled.div`
  width: 100%;
  display: flex;
  font-family: var(--font-Pretendard-SemiBold);
`;

const SelectBtn = styled.span<SelectBtnProps>`
  color: ${(props) =>
    props.$isSelected ? "white" : "rgba(255, 255, 255, 0.5)"};
  font-size: 18px;
  border-width: 0px;
  border-bottom-width: ${(props) => (props.$isSelected ? "2px" : "0px")};
  border-color: white;
  border-style: solid;
  padding: 10px 0px;
  margin-right: 16px;
  cursor: pointer;
`;

const NullDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 80px 0px 30px 0px;
`;

const Loading = styled(CenterView)`
  padding: 100px 0px 50px 0px;
  color: #858585;
  div.loading {
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    border: 3px solid #7955f0;
    border-top-color: #ffffff;
    border-radius: 100%;
    animation: spin 1s ease-in-out infinite;
  }
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`;
